import { render, staticRenderFns } from "./addPromotion.vue?vue&type=template&id=6ac1d5fc&scoped=true"
import script from "./addPromotion.vue?vue&type=script&lang=js"
export * from "./addPromotion.vue?vue&type=script&lang=js"
import style0 from "./addPromotion.vue?vue&type=style&index=0&id=6ac1d5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1d5fc",
  null
  
)

export default component.exports